/**
 * Enumeration of documentation topics
 * @internal
 */
export enum DocsId {
  Transformations,
  FieldConfig,
  FieldConfigOverrides,
}
